module.exports = __webpack_public_path__ + "static/media/welcome_event.a8a643bd.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/icons/welcome_event.png
 ** module id = 2251
 ** module chunks = 50
 **/